import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import user from './vserv/user'
import ticket from "./vserv/ticket"
import sla from "./vserv/sla"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    user,
    ticket,
    sla,
    'app-ecommerce': ecommerceStoreModule,
  },
  strict: process.env.DEV,
})
